import type { DTO, Nullable } from '~/core/types'

import type { SatisfactionBooking } from '../types/other'

export type ContactDTO = DTO<{ type: 'pro' | 'individual', email: string, message: string, name?: string, golf_name?: string, phone?: string }>

export type SatisfactionDTO = DTO<{
  reception: Nullable<number>
  facilities: Nullable<number>
  service: Nullable<number>
  price: Nullable<number>
  signature: string
  reception_tips: string
  facilities_tips: string
  service_tips: string
  price_tips: string
}>
export const useOtherService = () => {
  const config = useRuntimeConfig()
  const BASE_URL = `${config.public.apiBase}/api`

  return {
    patchAccountingMovementRefund(accountingMovement: string) {
      return fetchJson<FetchResult<void>>(
        'PATCH', `${BASE_URL}/accounting-movements/${accountingMovement}/refund`,
      )
    },
    getPrerequisite() {
      return fetchJson<FetchResult<{ has_promotions: boolean, ranges: { min: number, max: number } }>>(
        'GET', `${BASE_URL}/app-prerequisite`,
      )
    },
    postContact(dto: ContactDTO) {
      return fetchJson<FetchResult<void>, typeof dto>(
        'POST', `${BASE_URL}/contact`, dto,
      )
    },
    postCouponResend(coupon: number) {
      return fetchJson<FetchResult<void>>(
        'POST', `${BASE_URL}/coupons/${coupon}/resend`,
      )
    },
    getSatisfactionBooking(booking: Nullable<number>, signature: string) {
      if (!booking) {
        throw Error('Booking not defined')
      }
      return fetchJson<FetchResult<SatisfactionBooking>>(
        'GET', `${BASE_URL}/satisfaction/${booking}?signature=${signature}`,
      )
    },
    postSatisfactionBooking(booking: Nullable<number>, dto: SatisfactionDTO, signature: string) {
      if (!booking) {
        throw Error('Booking not defined')
      }
      return fetchJson<FetchResult<void>, SatisfactionDTO>(
        'POST', `${BASE_URL}/satisfaction/${booking}?signature=${signature}`, dto,
      )
    },
  }
}
